"use strict";

exports.__esModule = true;
exports.default = void 0;

var decimalFilter = function decimalFilter(value) {
  return value.replace(/([^\d.-]+)/gi, '');
};

var _default = decimalFilter;
exports.default = _default;